import { websiteContentPaths } from "components/configuration";

type Dict = Record<string, string>;
export type ContentPath = keyof typeof websiteContentPaths;

export const createNavigationUrl = (pathName: ContentPath, attributes?: Dict): string =>
  websiteContentPaths[pathName].replace(/:(\w+)/g, (_, key) => attributes?.[key] || "");
